import { Href, Redirect } from 'expo-router';

import { useAuth } from '@/contexts/authContext';

interface GuardWrapperProps {
  children: React.ReactNode;
  canAccess: ('NON_PROFIT_ORG' | 'ADMIN' | 'INDIVIDUAL')[];
  extraCondition?: boolean;
  href?: string;
}

const GuardWrapper = ({ children, canAccess, extraCondition, href }: GuardWrapperProps) => {
  const { state } = useAuth();

  if (!state.authReady) {
    return null;
  }

  const role = state.user?.user?.role;
  const condition = extraCondition ?? true;

  if (!role || !canAccess.includes(role) || !condition) {
    return <Redirect href={(href as Href) ?? '/unauthorized'} />;
  }

  return children;
};

export default GuardWrapper;
